export default class FeedbackService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  submit(feedback) {
    return this.$http.post('/api/feedback', {
      feedback
    });
  }
}



// WEBPACK FOOTER //
// ./services/feedback.service.js